module.exports = __webpack_public_path__ + "static/media/heavy-timer.1072a406.svg";